import { Heading, Paragraph } from 'grommet'
import Image from 'next/image'
import styled, { css } from 'styled-components'

const MAX_WIDTH_CONTAINER = 995

export const WrapperSection = styled.div`
  max-width: ${MAX_WIDTH_CONTAINER}px;
  ${({ theme }) => css`
    p {
      ${theme.getTypography('desktop', 'body', 'body2')}

      ${theme.below.mobileXL`
        ${theme.getTypography('mobile', 'body', 'body4')}
      `}
    }

    h2 {
      text-transform: none;
    }

    a {
      ${theme.getTypography('desktop', 'body', 'body2')}

      ${theme.below.mobileXL`
        ${theme.getTypography('mobile', 'body', 'body4')}
      `}
    }
  `}
`

export const ResultTitle = styled(Heading)`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'body', 'body2')}

    color: ${theme.newColors.dark};
    display: inline;

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'body', 'body2')}
    `}
  `}
`

export const Title = styled(Heading)`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'title1')}

    color: ${theme.newColors.primary};
    margin-bottom: ${theme.newSpaces.xs}px;
    text-transform: capitalize;
    width: 100%;

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'title', 'title2')}
    `}
  `}
`

export const SubTitle = styled(Paragraph)`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'body', 'body2')}

    a {
      ${theme.getTypography('desktop', 'body', 'body2')}
    }

    color: ${theme.newColors.darkGray};
    margin: ${theme.newSpaces.sm}px auto ${theme.newSpaces.md}px auto;
    max-width: 100%;
    text-align: justify;
    white-space: pre-wrap;

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'body', 'body3')}

      font-weight: ${theme.typography.mobile.body.body2.fontWeight};
      text-align: start;

      a {
       ${theme.getTypography('mobile', 'body', 'body3')}

        font-weight: ${theme.typography.mobile.body.body2.fontWeight};
      }
    `};
  `}
`

export const Wrapper = styled.div`
  ${({ theme }) => css`
    margin: 0 auto;
    margin-top: ${theme.newSpaces.sm}px;
    max-width: ${MAX_WIDTH_CONTAINER}px;
    width: 100%;

    ${theme.below.laptop`
      padding: 0 ${theme.newSpaces.sm}px;
    `}
  `};
`

export const Container = styled.div`
  .breadcrumbs {
    max-width: ${MAX_WIDTH_CONTAINER}px;
  }
`

export const Hexagon = styled(Image)`
  position: absolute;
  width: auto;

  ${({ theme }) => theme.below.laptop`
    display: none;
  `}
`

export const ContainerContent = styled.div`
  margin: auto;
  max-width: ${MAX_WIDTH_CONTAINER}px;
`
